__turbopack_context__.v({
  "account-panel-in": "x5LfpW_account-panel-in",
  "body": "x5LfpW_body",
  "card": "x5LfpW_card",
  "cardIcon": "x5LfpW_cardIcon",
  "close": "x5LfpW_close",
  "email": "x5LfpW_email",
  "header": "x5LfpW_header",
  "hello": "x5LfpW_hello",
  "link": "x5LfpW_link",
  "links": "x5LfpW_links",
  "logout": "x5LfpW_logout",
  "overlay": "x5LfpW_overlay",
  "panel": "x5LfpW_panel",
  "profile": "x5LfpW_profile",
  "profileText": "x5LfpW_profileText",
  "quickTitle": "x5LfpW_quickTitle",
  "root": "x5LfpW_root",
  "shortcuts": "x5LfpW_shortcuts",
  "title": "x5LfpW_title",
});
